import { render, staticRenderFns } from "./StoresIndex.vue?vue&type=template&id=3099c5e8&"
import script from "./StoresIndex.vue?vue&type=script&lang=js&"
export * from "./StoresIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports